<template>
  <div 
      class="page-wrapper page"
      :style="wrapperStyle"
      ref="wrapper"
  >
    <v-progress-linear
      v-if="loading && !page"
      :active="loading"
      :indeterminate="loading"
      absolute
      top
      color="primary"
    ></v-progress-linear>
    <v-skeleton-loader
      v-else-if="loading"
      type="image,heading,paragraph@3,image,paragraph@3"
      :class="[...pageClasses, 'page-loader']"
      :style="pageStyle"
    ></v-skeleton-loader>
    <div
      v-if="page"
      ref="page"
      :class="pageClasses"
      :style="pageStyle"
    >
      <rich-text-editor
          id="pdf-page-header"
          class="page-header"
          inline
          :html.sync="currentHeader"
          @imageLoaded="onImageUploaded"
          ref="header"
      ></rich-text-editor>
      <div class="page-content" ref="pageContent">
          <rich-text-editor
              id="pdf-page-content"
              :class="['max-height', 'max-width']"
              inline
              :html.sync="page.content"
              ref="content"
              stopGlobalListeners
          ></rich-text-editor>
      </div>
      <rich-text-editor
          id="pdf-page-footer"
          class="page-footer"
          inline
          :html.sync="currentFooter"
          @ready="onEditorsReady"
          ref="footer"
          stopGlobalListeners
      ></rich-text-editor>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DocumentPageComponent',
  components: {
    RichTextEditor: () => import('@/components/commonComponents/RichTextEditor'),
  },
  props: {
    value: Object,
    footer: String,
    header: String,
    backgroundImage: null,
    zoom: {
      type: Number,
      default: 1,
    },
    loading: Boolean,
  },
  data: () => ({
  }),
  computed: {
    id() {
      return this.page?.id || 0;
    },
    page: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit('input', v);
      },
    },
    currentHeader: {
      get() {
        return this.page?.is_cover ? this.page.header : this.header
      },
      set(v) {
        if (this.page?.is_cover) {
          if (this.clearHtml(this.page.header) === this.clearHtml(v)) {
            return;
          }
          this.page.header = v
        } else {
          if (this.clearHtml(this.header) === this.clearHtml(v)) {
            return;
          }
          this.$emit("update:header", v);
        }
      },
    },
    currentFooter: {
      get() {
        return this.page?.is_cover ? this.page.footer : this.footer
      },
      set(v) {
        if (this.page?.is_cover) {
          if (this.clearHtml(this.page.footer) === this.clearHtml(v)) {
            return;
          }
          this.page.footer = v
        } else {
          if (this.clearHtml(this.footer) === this.clearHtml(v)) {
            return;
          }
          this.$emit("update:footer", v);
        }
      },
    },
    wrapperStyle() {
      return {
        '--page-zoom': this.zoom,
      };
    },
    pageStyle() {
      return [
        this.getBackgroundStyle(this.page),
      ].filter(v => !!v).join(';');
    },
    pageClasses() {
      let cs = ['page'];
      return this.page ? [...cs, 
                          `page${this.page.num}`, 
                          this.page.is_cover ? 'cover' : 'inner', 
                          this.page.class
              ] : cs;
    },
  },
  /* watch: {
    currentHeader() {
      this.updateContentHeight();
    },
    currentFooter() {
      this.updateContentHeight();
    },
  },
  mounted() {
    this.updateContentHeight();
  },*/
  methods: {
    updateView() {
      if(!this.$refs?.content?.$el?.style) {
        return;
      }
      this.$refs.content.$el.style.display = "none";
      this.$nextTick(() => {
        this.$refs.content.$el.style.display = "table";
      })
    },
    /* updateContentHeight() {
      if (this.$refs.pageContent && this.$refs.header && this.$refs.footer) {
        const pH = this.$refs.page.offsetHeight;
        const hH = this.$refs.header.$el.offsetHeight;
        const fH = this.$refs.footer.$el.offsetHeight;
        this.$emit('contentHeight', pH - hH - fH);
      }
    }, */
    clearHtml(v) {
      return v
        .replace(/ \/>/g, '>')
        .replace(/\s+>/g, '>')
        .replace(/<!--\s*?[^\s?[][\s\S]*?-->/g, '')
        .replace(/>\s*</g, '><')
        .replace(/\t/g, ' ')
        .replace(/ {2,}/g, '')
        .replace(/^\s+/g, '')
        .replace(/\s+$/g, '');
    },
    getBackgroundStyle(v) {
      let bg = '';
      if(v?.background) {
        bg = v.background.indexOf('data:image/') === 0 ? v.background : this.$apiUrl.getFullUrl('') + v.background;
      }
      return bg && 'background-image:url(' + bg + ')' || '';
    },
    async html(v = this.page) {
      return `<div class="page page${v.num} ${v.class} ${v?.is_cover && 'cover' || 'inner'}" style="${this.getBackgroundStyle(v)}">
                  <div class="page-header">
                      ${this.clearHtml(v.is_cover ? v.header : this.header).replace('{@}', v.num)}
                  </div>
                  <div class="page-content">
                      ${this.clearHtml(v.content)}
                  </div>
                  <div class="page-footer">
                      ${this.clearHtml(v.is_cover ? v.footer : this.footer).replace('{@}', v.num)}
                  </div>
              </div>`;
    },
    onEditorsReady() {
      this.resetScroll();
      this.$emit('ready', true);
    },
    resetScroll() {
      this.$refs.header.resetScroll();
      this.$refs.footer.resetScroll();
      this.$refs.content.resetScroll();
      this.$refs.pageContent.scroll({top: 0, behavior: 'smooth'});
    },
    onImageUploaded(e) {
      this.$emit('imageUploaded', e);
    },
  },
}
</script>
<style lang="scss" scoped>
  .page-wrapper {
    margin: 0 auto;
    box-shadow: 0 4px 5px rgba(75, 75, 75, 0.2);
    border: 0;
    position: relative;
    transform-origin: center top;
    display: block!important;
    border-top: 0.5px solid rgba(0,0,0,0.05);
    transform-origin: center top 0px;
  }
  @supports (zoom: var(--page-zoom)) {
    .page-wrapper {
      zoom: var(--page-zoom);
    }
  }
  @supports not (zoom: var(--page-zoom)) {
    .page-wrapper {
      transform: scale(var(--page-zoom));
    }
  }
  /*.page:before {
    content: " ";
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    border: 1px #d3d3d3 solid;
    pointer-events: none;
  }*/
  .page-header, .page-footer {
    box-shadow: 0px 0px 1px 1px rgba(0, 0, 0, 0.05);
  }
  .page-loader {
    gap: 30px;
    padding: 10mm;
    position: absolute;
    z-index: 1;
    top: 0;
  }
</style>
